export default __webpack_public_path__ + "static/warehouse-dee893b4303c5d882c23ff22dbf40bf9.jpg";